import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.GettingStartedPage.RequestCreation', {
    title: 'Create a request',
    description:
        'You can create documents directly in ApprovalMax or pull them from your accounting system. You can create new documents manually or digitise documents with ApprovalMax Capture.',
    buttonText: 'Create request',
});
